import React from 'react'
import { connect } from 'react-redux'
import { getActiveElement, getUser, getElementById, getActiveTextEditor } from '@/store/getters'

import styles from './styles.scss'

/** Editors */
import TextContent from './editors/TextContent'
import VideoContent from './editors/VideoContent'
import IframeContent from './editors/IframeContent'
import ShapeContent from './editors/ShapeContent'
import ImageContent from './editors/ImageContent'

const ContentEditor = props => {
  const { actualElement, user, textEditor, element } = props


  const isShape = /square|circle|triangle|rhombus|line|arrow|star/.test(
    !!actualElement ? actualElement.type : ''
  )

  return (
    <React.Fragment>
      <div id="sideBar" className={'ba-mg-t-1 ' + styles['ba-over-x']}>
        {
          actualElement && !!textEditor && (
            <TextContent
              textEditor={textEditor}
              element={element}
              user={user}
            />
          )
        }
        {
          actualElement && actualElement.type === 'video' && (
            <VideoContent
              {...actualElement}
              element={element}
              user={user}
            />
          )
        }
        {
          actualElement && actualElement.type === 'iframe' && (
            <IframeContent
              {...actualElement}
              element={element}
              user={user}
            />
          )
        }
        {
          actualElement && isShape && (
            <ShapeContent
              {...actualElement}
              element={element}
              user={user}
            />
          )
        }
        {
          actualElement && actualElement.type === 'image' && (
            <ImageContent
              {...actualElement}
              element={element}
              user={user}
            />
          )
        }
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  const actualElement = getActiveElement(state)
  const user = getUser(state)
  const element = getElementById(state, actualElement && actualElement.id)
  const textEditor = getActiveTextEditor(state)
  return { actualElement, user, element, textEditor }
}

export default connect(mapStateToProps, null)(ContentEditor)



// WEBPACK FOOTER //
// ./src/pages/Editor/components/ContentEditor/index.js